// import request from '@/utils/request'
import audioRequest from '@/utils/audioRequest'
import { getToken } from '@/utils/auth'
import store from '@/store'
// 取得 ToB 客戶清單
export function getClientsList (id) {
  return audioRequest({
    method: 'GET',
    url: '/ear/public/api/web/v1/clients'
  })
}

// web
export function getClientData (cid) {
  return audioRequest({
    method: 'GET',
    url: `/ear/public/api/web/v1/clients/${cid}`
  })
}

// 取得特定資產資料
export function getClientCourseData (id) {
  return audioRequest({
    method: 'GET',
    url: `/ear/public/api/web/v1/client_assets/${id}`
    // url: `/ear/public/api/mobile/v1/client_assets/${id}`
  })
}

export function getIpToken (params) {
  return audioRequest({
    method: 'POST',
    url: '/lambda/createcustom',
    headers: params
  })
}

// 取得目前正在借閱的列表
export function getBorrowRecords () {
  const cid = store.state.toB.cid
  const token = getToken(cid)
  const bearerToken = {
    Authorization: `Bearer ${token}`
  }
  // console.log(bearerToken)
  return audioRequest({
    method: 'GET',
    url: '/ear/public/api/web/v1/borrow_records',
    // url: '/ear/public/api/mobile/v1/borrow_records',
    headers: bearerToken
  })
}

// 借閱課程
export function borrowCourse (data) {
  const cid = store.state.toB.cid
  const token = getToken(cid)
  const bearerToken = {
    Authorization: `Bearer ${token}`
  }
  return audioRequest({
    method: 'POST',
    url: '/ear/public/api/web/v1/borrow_records',
    // url: '/ear/public/api/mobile/v1/borrow_records',
    headers: bearerToken,
    data
  })
}

// 歸還課程
export function returnBorrowCourse (id) {
  const cid = store.state.toB.cid
  const token = getToken(cid)
  const bearerToken = {
    Authorization: `Bearer ${token}`
  }
  return audioRequest({
    method: 'PATCH',
    url: `/ear/public/api/web/v1/borrow_records/${id}`,
    // url: `/ear/public/api/mobile/v1/borrow_records/${id}`,
    headers: bearerToken
  })
}



// WEBPACK FOOTER //
// ./src/api/toB.js